import { __rest } from "tslib";
import React from 'react';
import Position from './Position';
/** @type {any} */
const PinBR = React.forwardRef((_a, ref) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (React.createElement(Position, Object.assign({ bottom: 0, position: "absolute", ref: ref, right: 0 }, props), children));
});
export default PinBR;
